import i18next from 'i18next';
import detector from 'i18next-browser-languagedetector';
import backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import {
  NS_APPLICATION,
  NS_ERROR,
  NS_FOOTER,
  NS_HEADER,
  NS_PAYMENT,
  NS_PLAN,
  NS_QUESTIONNAIRE,
  NS_QUOTATION,
  NS_REVIEW,
  NS_DOCUMENT,
  NS_STEPPER,
  NS_COMMON,
} from './namespaces';

import enQuestionnaire from '@/locales/en-US/questionnaire.json';
import enApplication from '@locales/en-US/application.json';
import enError from '@locales/en-US/error.json';
import enFooter from '@locales/en-US/footer.json';
import enHeader from '@/locales/en-US/header';
import enPayment from '@locales/en-US/payment.json';
import enPlan from '@locales/en-US/plan.json';
import enQuotation from '@/locales/en-US/quotation';
import enReview from '@locales/en-US/review.json';
import enStepper from '@locales/en-US/stepper.json';
import enDocument from '@locales/en-US/documents';
import enCommon from '@locales/en-US/common.json';

import myHeader from '@/locales/ms-MY/header';
import myQuestionnaire from '@/locales/ms-MY/questionnaire.json';
import myReview from '@locales//ms-MY/review.json';
import myApplication from '@locales/ms-MY/application.json';
import myError from '@locales/ms-MY/error.json';
import myFooter from '@locales/ms-MY/footer.json';
import myPayment from '@locales/ms-MY/payment.json';
import myPlan from '@locales/ms-MY/plan.json';
import myQuotation from '@/locales/ms-MY/quotation';
import myStepper from '@locales/ms-MY/stepper.json';
import myDocument from '@locales/ms-MY/documents';
import myCommon from '@locales/ms-MY/common.json';

export const resources = {
  en: {
    [NS_HEADER]: enHeader,
    [NS_FOOTER]: enFooter,
    [NS_ERROR]: enError,
    [NS_QUOTATION]: enQuotation,
    [NS_PLAN]: enPlan,
    [NS_QUESTIONNAIRE]: enQuestionnaire,
    [NS_APPLICATION]: enApplication,
    [NS_REVIEW]: enReview,
    [NS_DOCUMENT]: enDocument,
    [NS_PAYMENT]: enPayment,
    [NS_STEPPER]: enStepper,
    [NS_COMMON]: enCommon,
  },
  my: {
    [NS_HEADER]: myHeader,
    [NS_FOOTER]: myFooter,
    [NS_ERROR]: myError,
    [NS_QUOTATION]: myQuotation,
    [NS_PLAN]: myPlan,
    [NS_QUESTIONNAIRE]: myQuestionnaire,
    [NS_APPLICATION]: myApplication,
    [NS_REVIEW]: myReview,
    [NS_DOCUMENT]: myDocument,
    [NS_PAYMENT]: myPayment,
    [NS_STEPPER]: myStepper,
    [NS_COMMON]: myCommon,
  },
};

i18next
  /**
   * Load translation from /public/locales using HTTP back-end.
   * @see Docs {@link https://www.i18next.com/overview/plugins-and-utils#backends}
   * @see Example {@link https://github.com/i18next/react-i18next/tree/master/example/react/public/locales}
   * @see Source {@link https://github.com/i18next/i18next-http-backend}
   */
  .use(backend)
  /**
   * Detect user language.
   * @see Source {@link https://github.com/i18next/i18next-browser-languageDetector}
   */
  .use(detector)
  /**
   * Pass i18n instance to react-i18next.
   */
  .use(initReactI18next)
  /**
   * Initialize i18next configuration.
   * @see Docs {@link https://react.i18next.com/latest/i18next-instance}
   * @see Options {@link https://www.i18next.com/overview/configuration-options}
   */
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    resources,
  });

export default i18next;
